module.exports = __webpack_public_path__ + "static/img/official_account.170af89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/official_account.png
// module id = rX94
// module chunks = 1